import { SystemFont } from "@/types/common"

export const SYS_FONTS: SystemFont[] = [
  { label: 'Arial', value: 'Arial' },
  // { label: 'Times New Roman', value: 'Times-Roman' },
  // { label: 'Courier', value: 'courier' },
  { label: 'Helvetica', value: 'Helvetica' },
]

export const WEB_FONTS = [
]